import axios from 'axios';

import {
  TicketGroupFormState,
  TicketManagementCallGroup,
  TicketManagementTicketGroup,
  TicketManagementTicketGrouping,
  TicketManagementUser,
} from './types';

const ticketGroupParams = (form: TicketGroupFormState) => {
  const params: Record<string, unknown> = {
    name: form.name,
    internal_ticket_assignable: form.internal_ticket_assignable,
    customer_ticket_assignable: form.customer_ticket_assignable,
    user_ids: form.users.map((user) => user.id),
  };

  // Omit when unset so the DB default applies (Angular $resource did not send null).
  if (form.call_group_id != null) {
    params.call_group_id = form.call_group_id;
  }

  return { ticket_group: params };
};

export const fetchEditableTicketGroups = () =>
  axios
    .get<TicketManagementTicketGroup[]>('/ticket_groups.json', { params: { filter: 'editable' } })
    .then(({ data }) => data);

export const fetchTicketGroupings = () =>
  axios.get<TicketManagementTicketGrouping[]>('/ticket_groupings.json').then(({ data }) => data);

export const fetchUsers = () => axios.get<TicketManagementUser[]>('/users.json').then(({ data }) => data);

export const fetchCallGroups = () =>
  axios.get<TicketManagementCallGroup[]>('/call_groups.json').then(({ data }) => data);

export const createTicketGroup = (form: TicketGroupFormState) =>
  axios.post<TicketManagementTicketGroup>('/ticket_groups.json', ticketGroupParams(form)).then(({ data }) => data);

export const updateTicketGroup = (form: TicketGroupFormState) =>
  axios
    .patch<TicketManagementTicketGroup>(`/ticket_groups/${form.id}.json`, ticketGroupParams(form))
    .then(({ data }) => data);

export const destroyTicketGroup = (id: number) => axios.delete(`/ticket_groups/${id}.json`);

export const updateTicketGrouping = (slug: string, groupIds: number[]) =>
  axios.patch(`/ticket_groupings/${slug}.json`, {
    ticket_grouping: { group_ids: groupIds },
  });

export const extractErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    return (
      (error.response?.data as { message?: string } | undefined)?.message ||
      'An unknown error occurred. Please contact technical support.'
    );
  }

  return 'An unknown error occurred. Please contact technical support.';
};
